import StatsWidgets from "@rio-cloud/rio-uikit/StatsWidgets";
import StatsWidget from "@rio-cloud/rio-uikit/StatsWidget";
import StatsWidgetNumber from "@rio-cloud/rio-uikit/StatsWidgetNumber";
import StatsWidgetSpacer from "@rio-cloud/rio-uikit/StatsWidgetSpacer";
import { BigNumberOccurrence } from "../../../models/occurrence";
import { useLocation } from "react-router-dom";
import { formatMilisecondsInDaysHoursMinutes } from "../../../utils/dateUtils";

export const BigNumbers = (props: {
  bigNumberAnalytics: BigNumberOccurrence;
  finishedFilter: string[];
  loading?: boolean;
  isFilteredByStep?: boolean | null;
}) => {
  const location = useLocation();
  const isHistorico = location.pathname.includes("history");

  const colorPrimary = isHistorico ? "text-color-dark" : "text-color-primary";
  const colorWarning = isHistorico ? "text-color-dark" : "text-color-warning";

  const quantityWidgets = () => [
    (!props.isFilteredByStep && props.finishedFilter.includes('true') || props.finishedFilter.length === 0) && {
      label: "Chamados concluídos",
      value: props.bigNumberAnalytics.totalOfFinalizedOccurrence < 0 ? 0 : props.bigNumberAnalytics.totalOfFinalizedOccurrence,
      color: colorPrimary,
    },
    (!props.isFilteredByStep && props.finishedFilter.includes('false') || props.finishedFilter.length === 0) && {
      label: "Chamados não iniciados",
      value: props.bigNumberAnalytics.totalOfNotStartedOccurrence < 0 ? 0 : props.bigNumberAnalytics.totalOfNotStartedOccurrence,
      color: colorPrimary,
    },
    (props.finishedFilter.includes('false') || props.finishedFilter.length === 0) && {
      label: "Chamados em andamento",
      value: props.bigNumberAnalytics.totalOfInProgressOccurrence < 0 ? 0 : props.bigNumberAnalytics.totalOfInProgressOccurrence,
      color: colorPrimary,
    }
  ].filter(el => el !== false);

  return (
    <>
      <StatsWidgets className="margin-bottom-20">
        <StatsWidget>
          <StatsWidget.Body>
            {
              quantityWidgets()
                .map((item, index) => (
                  <>
                    <StatsWidgetNumber
                      className={item.color}
                      value={props.loading ? '-' : item.value}
                      label={item.label}
                    />
                    {index !== quantityWidgets().length - 1 && <StatsWidgetSpacer />}
                  </>
                ))
            }
          </StatsWidget.Body>
        </StatsWidget>

        <StatsWidget>
          <StatsWidget.Body>
            <StatsWidgetNumber
              className={colorWarning}
              value={props.loading ? '-' : formatMilisecondsInDaysHoursMinutes(props.bigNumberAnalytics.totalInService * 60 * 1000)}
              label="Tempo total em serviço"
            />
            <StatsWidgetSpacer />
            <StatsWidgetNumber
              className={colorWarning}
              value={props.loading ? '-' : formatMilisecondsInDaysHoursMinutes(props.bigNumberAnalytics.averageInService * 60 * 1000)}
              label="Tempo médio em reparo"
            />
          </StatsWidget.Body>
        </StatsWidget>
      </StatsWidgets>
    </>
  );
};
